import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";
import { MODAL_TEXTS } from "app/pages/activation/components/Topics/texts";

import { emptySuggestionsKeys } from "../automationKeys";

import * as SC from "./styles";

export const EmptySuggested = () => (
    <SC.EmptyStateContainer data-automation={emptySuggestionsKeys.container}>
        <SWReactIcons
            iconName="no-data-tree"
            size="xxl"
        />
        <SC.EmptyText data-automation={emptySuggestionsKeys.text}>{translate(MODAL_TEXTS.emptyStateText)}</SC.EmptyText>
    </SC.EmptyStateContainer>
);
